import { extendTheme, withDefaultColorScheme, type ThemeConfig } from "@chakra-ui/react";
import { colors } from "./foundations/colors";
import { fonts } from "./foundations/typography";
import { radii } from "./foundations/radii";
import { shadows } from "./foundations/shadows";
import { semanticTokens } from "./foundations/semanticTokens";
import { styles } from "./foundations/styles";
import { textStyles } from "./foundations/textStyles";
import { layerStyles } from "./foundations/layerStyles";
import { components } from "./components";

const config: ThemeConfig = { initialColorMode: "light", useSystemColorMode: false };

/**
 * "Fresh Ledger" theme for the myBidfood Partner Portal.
 * `withDefaultColorScheme` is scoped to the components that still derive colours from `colorScheme`
 * (Checkbox / Radio / Switch keep their own `leaf` default and are deliberately excluded).
 */
export const theme = extendTheme(
  { config, colors, fonts, radii, shadows, semanticTokens, styles, textStyles, layerStyles, components },
  withDefaultColorScheme({
    colorScheme: "navy",
    components: ["Button", "Badge", "Tag", "Progress", "CircularProgress", "Slider", "Tabs", "Avatar", "PinInput"],
  })
);

export { gradients } from "./foundations/semanticTokens";
export { duration, ease, spring, reducedTransition, cssTransition, useReducedMotion } from "./foundations/motion";
export type { CubicBezier } from "./foundations/motion";

export default theme;
